export default __webpack_public_path__ + "static/media/upc.9287e7be.png";